import React, { useContext, useEffect, useRef } from "react";
import { Dropdown } from "react-bootstrap";

import AppContext from "../../../contexts/AppContext";
import { useLocalStorage } from "../../../hooks/LocalStorage";
import { ILanguage } from "../../../types/language/language.d";
import { LanguageEngIcon, LanguageGeoIcon, LanguageRusIcon } from '../Flags';

export default function CasFooter() {
  const { languages, setLanguage } = useContext(AppContext);
  const [storedLanguage, storeLanguage] = useLocalStorage("language", {});
  const firstLoad = useRef(true);

  useEffect(() => {
    if (
      storedLanguage &&
      !Object.keys(storedLanguage).length &&
      languages?.length
    ) {
      const defaultLanguage = languages?.find((language) => language.isDefault);
      storeLanguage(defaultLanguage);
      if (defaultLanguage) {
        setLanguage(defaultLanguage);
      }
    }

    if (storedLanguage) {
      if (firstLoad.current) {
        setLanguage(storedLanguage);
        firstLoad.current = false;
      }
      const storedLanguageAvailable = languages?.find(
        (language) => storedLanguage.key === language.key
      );
      if (storedLanguageAvailable && !storedLanguageAvailable?.enabled) {
        const defaultLanguage = languages?.find(
          (language) => language.isDefault
        );
        if (defaultLanguage) {
          storeLanguage(defaultLanguage);
          setLanguage(defaultLanguage);
        }
      }
    }
  }, [languages, storeLanguage, storedLanguage, setLanguage]);

  const handleSelect = (language: ILanguage) => {
    storeLanguage(language);
    setLanguage(language);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const activeLanguages = () => {
    if (languages && languages.length) {
      return languages?.filter((item) => {
        return item.enabled && item.active;
      });
    }
    return [];
  };

  const renderLanguageIcon = (language: string) => {
    switch (language) {
      case 'ka':
        return <LanguageGeoIcon />;
      case 'eng':
        return <LanguageEngIcon />;
      case 'ru':
        return <LanguageRusIcon />;
      default:
        return <LanguageGeoIcon />;
    }
  };

  return (
    <div className="cas-footer">
      <div className="cas-footer__inner">
        <div className="spacer"></div>
        <div className="cas-footer__lang">
          {languages && activeLanguages().length > 1 && (
            <Dropdown>
              <Dropdown.Toggle variant="link" id="dropdown-basic">
                {renderLanguageIcon(storedLanguage.key)}
                {storedLanguage.title}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                {languages?.map((x) => (
                  <Dropdown.Item onClick={() => handleSelect(x)} key={x.key}>
                    {x.title}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          )}
        </div>
      </div>
    </div>
  );
}
